import { GoalFilterDocument, UserSettings } from '@griply/types';

import { defaultGoalsOverviewFilterDocument } from './constants/default-goals-overview-filter-document';

// The standalone Timeline page (web /timeline) keeps its own filter document so
// it filters independently from the Goals-list page. Unlike
// `buildGoalsOverviewFilterDocument`, there is no legacy `goalSortingMode` /
// `goalGroupBy` fallback — the Timeline is a new surface with no legacy store.
export const buildGoalsTimelineFilterDocument = (
  settings: UserSettings | undefined,
): GoalFilterDocument => ({
  ...defaultGoalsOverviewFilterDocument,
  ...(settings?.filters?.goalsTimeline ?? {}),
});
